module.exports = __webpack_public_path__ + "static/media/credit.c5fdee1f.jpg";